import { TabPane } from "reactstrap";
import React, { useMemo, useState } from "react";
import SettingsPanel from "../../components/SettingsPanel";
import DepartmentToStaff from "./DepartmentToStaff";
import DepartmentsSettings from "./Departments";
import DepartmentDetails from "./DepartmentDetails";
import DepartmentTopology from "./Topology";

const OrganisationDepartmentSettings = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const Tabs = [
    {
      id: "1",
      name: "Departments",
    },
    {
      id: "2",
      name: "Department To Staff",
    },
    {
      id: "3",
      name: "Department Details",
    },
    // Task 24461 - the hierarchy as a diagram rather than a parent id column.
    {
      id: "4",
      name: "Topology",
    },
  ];

  const Content = useMemo(() => {
    return [
      {
        id: "1",
        content: (
          <DepartmentsSettings
            setSelectedDepartment={setSelectedDepartment}
            setActiveTab={setActiveTab}
          />
        ),
      },
      {
        id: "2",
        content: <DepartmentToStaff />,
      },
      {
        id: "3",
        content: <DepartmentDetails selectedDepartment={selectedDepartment} />,
      },
      {
        id: "4",
        content: <DepartmentTopology />,
      },
    ];
  }, [activeTab, selectedDepartment]);
  return (
    <SettingsPanel
      title="Organisation Hierarchy Settings"
      description="Departments, department-to-staff mappings and department details."
      tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
      value={activeTab}
      onChange={setActiveTab}
    >
      <TabPane tabId={activeTab}>
        {Content?.find((item) => item.id === activeTab).content}
      </TabPane>
    </SettingsPanel>
  );
};

export default OrganisationDepartmentSettings;
